export default "__VITE_ASSET__CBwFWv2n__"